<template>
  <div class="relative bg-surface-primary flex flex-col items-center pt-xl px-l pb-l rounded-4xl gap-l w-[317px] h-[419px]">
    <div class="absolute top-l right-l">
      <Skeleton class="h-8 w-8 rounded-md" />
    </div>
    <Skeleton class="w-[116px] h-[163px] rounded-xl" />
    <div class="flex flex-col gap-2xs items-center w-full">
      <Skeleton class="h-5 w-3/4 rounded" />
      <Skeleton class="h-5 w-2/3 rounded" />
    </div>
    <div class="flex flex-col gap-3xs items-center w-full">
      <Skeleton class="h-3 w-1/2 rounded" />
      <Skeleton class="h-3 w-2/3 rounded" />
      <Skeleton class="h-3 w-1/3 rounded" />
    </div>
  </div>
</template>
